class SeznamMap {


    constructor(mapElement, apiKey)
    {
        this.seznamMap = L.map(mapElement.get(0)).setView([49.4313369, 15.2233569], 9);
        this.markersGroup = null;

        L.tileLayer(`https://api.mapy.cz/v1/maptiles/basic/256/{z}/{x}/{y}?apikey=${apiKey}`, {
            minZoom: 0,
            maxZoom: 19,
            attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
        }).addTo(this.seznamMap);

        const LogoControl = L.Control.extend({
            options: {
                position: 'bottomleft',
            },

            onAdd: function () {
                const container = L.DomUtil.create('div');
                const link = L.DomUtil.create('a', '', container);

                link.setAttribute('href', 'http://mapy.cz/');
                link.setAttribute('target', '_blank');
                link.innerHTML = '<img src="https://api.mapy.cz/img/api/logo.svg" />';
                L.DomEvent.disableClickPropagation(link);

                return container;
            },
        });

        new LogoControl().addTo(this.seznamMap);

    }

    createMarkerIcon(markerPath = BASE_PATH + '/images/mapmarker.png')
    {

        return L.icon({
            iconUrl: markerPath,
            iconSize: [20, 43],
            iconAnchor: [10, 50],
            popupAnchor: [24, 10],
            //shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
            //shadowSize: [41, 41]
        });

    }

    appendMarkers(markers = [], markerIcon = null)
    {

        if (markerIcon === null) {
            markerIcon = this.createMarkerIcon();
        }

        let markersGroup = this.markersGroup;

        if (markersGroup === null) {
            markersGroup = L.markerClusterGroup();
        }

        for (let i = 0; i < markers.length; i++) {

            let marker = L.marker([parseFloat(markers[i][1]), parseFloat(markers[i][2])], {icon: markerIcon})
                          .bindPopup(markers[i][0]);

            markersGroup.addLayer(marker);
        }

        if (this.markersGroup === null) {
            this.markersGroup = markersGroup;
            this.seznamMap.addLayer(this.markersGroup);
        }

    }

    showAllMarkers(maxZoom = 14)
    {

        this.seznamMap.whenReady(() => {
            this.seznamMap.fitBounds(this.markersGroup.getBounds(), {maxZoom: maxZoom});
        });

    }

    setGrayScale()
    {

        this.seznamMap.eachLayer(function (layer) {
            if (layer instanceof L.TileLayer) {
                layer.on('tileload', function (event) {
                    event.tile.style.filter = 'grayscale(100%)';
                });
            }
        });

    }

}